import { Button, GenericDialog, InputGroup, Partnership } from '@/common'
import { useCallback, useState } from 'react'
import { useSession } from '@/shared/hooks/useSession'
import useI18n from '@/shared/hooks/useI18n'
import { useRejectPartnershipInvitation } from '@/shared/hooks/api/partnerships'

export default function RejectImporterDialog({
  isOpen,
  onClose,
  partnership
}: {
  isOpen: boolean
  onClose: () => void
  partnership?: Partnership
}) {
  const { t } = useI18n()
  const {
    session: {
      organization: { id: organizationId }
    }
  } = useSession()

  const { mutateAsync: rejectPartnership, isPending: isRejecting } =
    useRejectPartnershipInvitation()

  const [reason, setReason] = useState('')

  const onRejectClick = useCallback(async () => {
    if (!partnership) {return}
    await rejectPartnership({
      partnershipId: partnership.id,
      organizationId,
      reason
    })
    onClose()
  }, [rejectPartnership, partnership, onClose, organizationId, reason])

  return (
    <GenericDialog
      isOpen={isOpen}
      close={onClose}
      title={t('importers:importerIncomingList.rejectPartnershipDialog.title')}
    >
      <div className="space-y-6">
        <p>{t('importers:importerIncomingList.rejectPartnershipDialog.description')}</p>
        <InputGroup
          label={t('importers:importerIncomingList.rejectPartnershipDialog.reason')}
          value={reason}
          onChange={evt => setReason(evt.target.value)}
        />
        <footer className="gap-2 flex justify-end">
          <Button
            onClick={onRejectClick}
            isLoading={isRejecting}
            variant="danger"
            className="w-full"
          >
            {t('common:actions.reject')}
          </Button>
          <Button className="w-full" variant="neutral" onClick={onClose}>
            {t('common:actions.cancel')}
          </Button>
        </footer>
      </div>
    </GenericDialog>
  )
}
